import { AxiosInstance, AxiosResponse } from "axios";
import { User } from "@intouchhealth/oidc-client";
import Logger from "../utils/logger";

const domain = window.location.hostname.toLowerCase();
const userSessionItem = `oidc.user:${
  domain.includes("visit")
    ? process.env.REACT_APP_OIDC_AUTHORITY_VIS
    : process.env.REACT_APP_OIDC_AUTHORITY
}:${process.env.REACT_APP_OIDC_CLIENT_ID}`;

export function configureInstance(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.request.use(
    (config) => {
      const rawUser = window.sessionStorage.getItem(userSessionItem);
      const storedUser: User | null = rawUser ? JSON.parse(rawUser) : null;
      if (storedUser?.access_token && config?.headers) {
        config.headers.Authorization = `Bearer ${storedUser.access_token}`;
      }

      return config;
    },
    (error) => {
      console.error("[axios request interceptor error]", error);
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.error("[axios response error FULL]", error);

      console.error("[axios response error details]", {
        message: error?.message,
        code: error?.code,
        status: error?.response?.status,
        responseData: error?.response?.data,
        responseHeaders: error?.response?.headers,
        requestUrl: error?.config?.url,
        baseURL: error?.config?.baseURL,
        fullUrl: `${error?.config?.baseURL ?? ""}${error?.config?.url ?? ""}`,
      });

      const status = error.response?.status ?? 500;

      if (status === 500) Logger(["An unexpected error has occurred"]);

      return Promise.reject(error);
    },
  );
}

export function configureHttpRequestsWrapper(axiosInstance: AxiosInstance) {
  const responseBody = (response: AxiosResponse) => response.data;

  return {
    get: (url: string) => axiosInstance.get(url).then(responseBody),
  };
}
